import React from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'
import { Project } from '@leverege/api-redux'
import { Pane } from '@leverege/ui-elements'

import { BreadcrumbActions } from '~/actions'
import EnumGroupScreen from './EnumGroupScreen'
import EnumItemScreen from './EnumItemScreen'

class EnumHomeScreen extends React.Component {

  constructor( props ) {
    super( props )
    const { match : { params : { projectId } } } = props
    this.projectId = projectId
  }

  componentDidMount() {
    const { match : { params : { enumType } } } = this.props
    this.updateBreadcrumbs( enumType )
  }

  componentDidUpdate() {
    const { match : { params : { enumType } } } = this.props
    this.updateBreadcrumbs( enumType )
  }

  updateBreadcrumbs( enumType ) {
    const { dispatch, resourceType } = this.props
    if ( enumType ) {
      dispatch( BreadcrumbActions.setBreadcrumbs( [
        { name : `${resourceType === 'resourceEnum' ? 'Resource ' : ''}Enums`,
          link : `/project/${this.projectId}/${resourceType}` },
        { name : enumType }
      ] ) )
    } else {
      dispatch( BreadcrumbActions.setBreadcrumbs( [ { name : `${resourceType === 'resourceEnum' ? 'Resource ' : ''}Enums` } ] ) )
    }
  }

  onSelect = ( { data : enumType } ) => {
    const { history, match, resourceType } = this.props
    this.updateBreadcrumbs( enumType )
    history.push( `/project/${match.params.projectId}/${resourceType}/${enumType}` )
  }

  render() {
    const { match : { params : { enumType } }, resourceType } = this.props
    const baseActions = Project( this.projectId )
    const getMethod = `get${resourceType.charAt( 0 ).toUpperCase()}${resourceType.slice( 1 )}`
    const groupActions = baseActions[`${resourceType}s`]()
    return (
      <Pane style={{ height : '100%', overflow : 'hidden' }} variant="view">
        <Route
          key={`/project/:projectId/${resourceType}`}
          exact
          path={`/project/:projectId/${resourceType}`}
          render={() => (
            <EnumGroupScreen
              onSelect={this.onSelect}
              actions={groupActions}
              itemActions={type => baseActions[resourceType]( type )}
              get={state => groupActions[`${getMethod}s`]( state )} />
          )} />
        <Route
          key={`/project/:projectId/${resourceType}/:enumType`}
          exact
          path={`/project/:projectId/${resourceType}/:enumType`}
          render={() => (
            <EnumItemScreen
              enumType={enumType}
              actions={type => baseActions[resourceType]( type )}
              get={state => baseActions[resourceType]( enumType )[getMethod]( state )} />
          )} />
      </Pane>
    )
  }
}

export default connect( () => {
  const resourceType = window.location.pathname.indexOf( '/resourceEnum' ) >= 0 ? 'resourceEnum' : 'enum'
  return { resourceType }
} )( EnumHomeScreen )
